// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__bGVvN","label":"CategoryService_label__1eMRH","location":"CategoryService_location__2zUYU"};